import script from "./TeamArea.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamArea.vue?vue&type=script&setup=true&lang=js"

import "./TeamArea.vue?vue&type=style&index=0&id=51703ca1&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51703ca1"]])

export default __exports__